import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { navLinks } from './constants';
import { landingImages, Images, Svg } from 'assets';
import { RequestDemoButton } from 'components';

export const TopBar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [menuIsShown, setMenuIsShown] = useState(false);
    const [headerStyles, setHeaderStyles] = useState({
        background: 'transparent',
        boxShadow: 'none',
    });

    const handleScroll = () => {
        if (window.scrollY >= 10) {
            if (location.pathname === '/') {
                setHeaderStyles({
                    background: '#12141D',
                    boxShadow: ' 0 20px 24px -4px rgba(16, 24, 40, 0.08), 0 8px 8px -4px rgba(16, 24, 40, 0.03)',
                });
            } else {
                setHeaderStyles({
                    background: 'white',
                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                });
            }
        } else {
            setHeaderStyles({
                background: 'transparent',
                boxShadow: 'none',
            });
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [location.pathname]);

    const navigateHome = () => {
        navigate('/');
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
        setMenuIsShown(false);
    };

    const headerLogo = location.pathname === '/' ? <Svg.HeaderLogo /> : <landingImages.BlackLogo />;

    return (
        <nav className="topbar-container" style={headerStyles}>
            <div className="topbar-content ">
                <button onClick={navigateHome} className="top-bar-logo">
                    {headerLogo}
                </button>

                <div className="desktop-nav">
                    <div className={`nav-links-container ${location.pathname === '/' ? 'nav-links-container-home' : ''}`}>
                        <ul className={'nav-links-list'}>
                            {navLinks.map((navLink, index) => (
                                <li key={index}>
                                    {navLink?.target === '_blank' ? (
                                        <a
                                            href={navLink.path}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={location?.pathname === navLink.path ? 'active-link' : ''}
                                        >
                                            {navLink.name}
                                        </a>
                                    ) : (
                                        <NavLink to={navLink.path} className={location?.pathname === navLink.path ? 'active-link' : ''}>
                                            {navLink.name}
                                        </NavLink>
                                    )}
                                </li>
                            ))}
                        </ul>

                        <div className="sing-and-book">
                            <NavLink to={'/login'}>Sign In</NavLink>

                            <RequestDemoButton className="book-demo-button" arrowIcon />
                        </div>
                    </div>
                </div>

                <div className="tablet-nav">
                    <button
                        className={`menu-button ${location?.pathname !== '/' ? 'menu-button-blue' : ''}`}
                        onClick={() => setMenuIsShown((prevState) => !prevState)}
                    >
                        <img src={menuIsShown ? Images.MenuCloseIcon : Images.MenuIcon} alt="menu" />
                    </button>
                    <div className={`menu-container ${menuIsShown ? 'shown' : ''}`} onClick={() => setMenuIsShown(false)}>
                        <div className="nav-links-container">
                            <ul className="nav-links-list column">
                                {navLinks.map((navLink, index) => (
                                    <li key={index}>
                                        <NavLink to={navLink.path} className={location?.pathname === navLink.path ? 'active-link' : ''}>
                                            {navLink.name}
                                        </NavLink>
                                    </li>
                                ))}
                            </ul>

                            <div className="sing-and-book">
                                <NavLink to={'/login'}>Sign In</NavLink>

                                <RequestDemoButton className="book-demo-button" arrowIcon />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
};
